import { ForestProductGroupDetail } from '../../../../components/ForestProduct';

export function ForestProductGroupDetails() {
  return <ForestProductGroupDetail />;
}
